module.exports = __webpack_public_path__ + "img/left.5613d282.svg";